import * as React from 'react';
import kebabCase from 'lodash/kebabCase';
import lowerCase from 'lodash/lowerCase';
import snakeCase from 'lodash/snakeCase';

import navigate from 'libs/router/navigate';

import ActionButton from 'components/buttons/action-button/ActionButton';

import { __t, applyTranslations } from 'utils/language';

import './campaigns-call-to-action.scss';

applyTranslations(require('./campaigns-call-to-action.i18n.json'));

import type { CallToActionType } from './types';

interface Props {
  influencerId?: number,
  type: CallToActionType
}

const MSG_KEY = 'campaigns_call_to_action';

const CampaignsCallToAction: React.FC<Props> = ({
  influencerId,
  type
}): JSX.Element => {
  const handleButtonClick = (): void => {
    let url = `/content-creator/profiles/${influencerId}`;

    if (type === 'profileApprovedNoBoost') {
      url = `${url}/edit`;
    }

    navigate.to(url);
  };

  const renderButton = (): React.ReactNode => {
    const textKey = type !== 'profileApprovedNoBoost' ? 'view' : 'complete';

    return (
      <div className="campaigns-call-to-action__button">
        <ActionButton
          color="secondary"
          onClick={handleButtonClick}
        >
          {__t(`${MSG_KEY}.buttons.${textKey}`)}
        </ActionButton>
      </div>
    );
  };

  return (
    <div className="campaigns-call-to-action">
      <div className="campaigns-call-to-action__image">
        <img
          src={`/static/images/${kebabCase(type)}.png`}
          className="lazyload"
          alt={lowerCase(type)}
        />
      </div>
      <div className="campaigns-call-to-action__heading">
        {__t(`${MSG_KEY}.${snakeCase(type)}.heading`)}
      </div>
      <div className="campaigns-call-to-action__description">
        {__t(`${MSG_KEY}.${snakeCase(type)}.description`)}
      </div>
      {renderButton()}
    </div>
  );
};

export default CampaignsCallToAction;
